module.exports = __webpack_public_path__ + "static/img/id_front.4aab72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_front.png
// module id = UoGZ
// module chunks = 1